"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateName = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var page = require("page");
var inputs_component_1 = require("../../../components/inputs.component");
var commonweb_utils_1 = require("commonweb-utils");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var name_1 = require("../../../utils/name");
var UpdateName = /** @class */ (function (_super) {
    tslib_1.__extends(UpdateName, _super);
    function UpdateName(props) {
        var _this = _super.call(this, props) || this;
        _this.submitHandler = function (event) {
            if (event) {
                event.preventDefault();
            }
            var nameChangeReason = commonweb_utils_1.objectUtils.safeGet(_this.state, "pageInputs.nameChangeForm.form.nameChangeType.value");
            triggerOperationResult_1.triggerOperationResult("reason of name change", "SUCCESS", nameChangeReason);
            page(nameChangeReason);
        };
        _this.getFormTemplate = function () {
            var formElementsArray = [];
            var nameContent = _this.props.content.name;
            var inputs = _this.state.pageInputs[_this.state.pageName];
            // tslint:disable-next-line:forin no-for-in
            for (var key in inputs.form) {
                formElementsArray.push({
                    elementName: key,
                    elementProperties: inputs.form[key],
                });
            }
            return (React.createElement("form", { className: "newNameChange-name_change_form", onSubmit: function (event) { return _this.submitHandler(event); } },
                inputs.formMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "form-alert" }, inputs.formMessage)) : null,
                React.createElement(pp_react_1.Text, { size: "xl3", className: "newNameChange-name_change_header" }, nameContent.newNameHomeScreen.changeReason),
                formElementsArray.map(function (formElement) { return (React.createElement(inputs_component_1.default, { key: formElement.elementName, id: formElement.elementName, name: formElement.elementName, elementType: formElement.elementProperties.elementType, elementConfig: formElement.elementProperties.elementConfig, value: formElement.elementProperties.value, isInvalid: !formElement.elementProperties.isValid, shouldValidate: formElement.elementProperties.validation, isTouched: formElement.elementProperties.isTouched, changed: function (event) {
                        return name_1.inputChangedHandler(event, formElement.elementName, _this.state, _this.setState.bind(_this));
                    }, helperText: formElement.elementProperties.helperText || null, isDisabled: _this.state.showSpinner })); }),
                React.createElement(pp_react_1.Text, { size: "sm", className: "newNameChange-name_change_reason_disclaimer" }, nameContent.newNameHomeScreen.disclaimer),
                React.createElement(pp_react_1.Button, { className: "newNameChange-name_submit_button", name: "nameChangeReasonSubmit", disabled: _this.state.showSpinner, type: "submit" }, _this.props.content.common.next)));
        };
        var nameContent = props.content.name;
        var allowedMinorNameChange = commonweb_utils_1.objectUtils.safeGet(props, "name.allowMinorNameChange") || false;
        var legalChangeLink = commonweb_utils_1.objectUtils.safeGet(props, "links.legalNameChangeUrl.linkUrl") ||
            "legalChangeLink";
        var majorChangeLink = commonweb_utils_1.objectUtils.safeGet(props, "links.majorNameChangeUrl.linkUrl") ||
            "majorChangeLink";
        var minorChangeLink = commonweb_utils_1.objectUtils.safeGet(props, "links.minorNameChangeUrl.linkUrl") ||
            "minorChangeLink";
        var nameChangeTypeOptions = [
            {
                optionId: legalChangeLink,
                optionValue: nameContent.newNameHomeScreen.legal.title,
            },
            {
                optionId: majorChangeLink,
                optionValue: nameContent.newNameHomeScreen.major.title,
            },
        ];
        if (allowedMinorNameChange && props.name.userCiped) {
            nameChangeTypeOptions.push({
                optionId: minorChangeLink,
                optionValue: nameContent.newNameHomeScreen.minor.title,
            });
        }
        _this.state = {
            showSpinner: false,
            userCiped: false,
            pageName: "nameChangeForm",
            formIsValid: true,
            errorMessage: "",
            pageInputs: {
                nameChangeForm: {
                    form: {
                        nameChangeType: {
                            elementType: "radio",
                            elementConfig: {
                                type: "radio",
                                placeholder: "",
                                suggestionText: commonweb_utils_1.objectUtils.safeGet(props, "content.name.changeReason.error") || "",
                                options: nameChangeTypeOptions,
                            },
                            value: legalChangeLink,
                        },
                    },
                    formIsValid: true,
                    formMessage: "",
                },
            },
        };
        return _this;
    }
    UpdateName.prototype.render = function () {
        return (React.createElement("div", { className: "generic-container" }, this.getFormTemplate()));
    };
    return UpdateName;
}(React.Component));
exports.UpdateName = UpdateName;
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti;
    var name = commonweb_utils_1.objectUtils.safeGet(account, "name") || {};
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        name: name,
        links: links,
        fpti: fpti,
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        dispatch: dispatch,
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(UpdateName);
